/*
 * @Author: Bai.Zhiming
 * @Date: 2021-02-26 14:32:18
 * @LastEditTime: 2021-03-25 20:07:28
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\MC\left\left.js
 * @Description: 消息中心左侧导航
 */

angular.module('messageCenterLeftModule', [])
    . controller('messageCenterLeftCtrl', ['$scope', '$element', '$timeout', '$state', 'trsHttpService', '$q', 'permissionService', 'loginService', '$rootScope', 'messagePublishService', 'publicToolService',
        function($scope, $element, $timeout, $state, trsHttpService, $q, permissionService, loginService, $rootScope, messagePublishService, publicToolService) {
            initStatus();
            initData();

            /**
         * [expandLeve1 description] 展开一级菜单
         * @param  {[type]} leve1Name [description] 被展开的一级菜单
         * @return {[type]}           [description]
         */
            $scope.expandLeve1 = function(leve1Name) {
                let index = $scope.status.expandedNodes.indexOf(leve1Name);
                let flag = index >= 0;
                if (flag) {
                    $scope.status.expandedNodes.splice(index, 1);
                } else {
                    $scope.status.expandedNodes.push(leve1Name);
                }
            };

            /**
             * [selectLeve2 description]选中二级菜单
             *
             * @param   {[type]}  leve2Name   [leve2Name description]二级菜单名称
             * @param   {[type]}  leve1Name   [leve1Name description]所属一级菜单名称
             * @param   {[type]}  activeLeve  [activeLeve description]
             *
             * @return  {[type]}              [return description]
             */
            $scope.selectLeve2 = function(leve2Name, leve1Name, activeLeve) {
                $scope.status.selectedLeve2 = leve2Name;
                let params = {};
                if (leve2Name === 'noticeinfo') {
                    $scope.status.selectedLeve3 = activeLeve;
                    params.id = activeLeve;
                } else {
                    $scope.status.selectedLeve3 = '';
                }
                let routerName = `front.mc.${leve1Name}.${leve2Name}`;
                $state.go(routerName, params, { reload: routerName });
            };

            /**
         * [leve1Selected description] 一级菜单的子菜单有没有被选中
         * @param  {[type]} leve1Name [description] 一级菜单名称
         * @return {[type]}           [description]
         */
            $scope.leve1Selected = function(leve1Name) {
                let leve2 = $scope.status.selectedLeve2;
                if (leve2 === 'collaborationmessage' || leve2 === 'resourceupdatemessage' || leve2 === 'propagandadepartmentmessage' || leve2 === 'systemmessage' || leve2 === 'messagereceivingconfig') {
                    return 'message' === leve1Name;
                } else {
                    return 'notice' === leve1Name;
                }
            };

            /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
            function initStatus() {
                $scope.status = {
                    expandedNodes: [],
                    messageList: {},
                };
                $scope.data = {};
                $scope.$root.narrowNavigation = true;
            }

            /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
            function initData() {
                getNoticeList();
                isAdministrator();
                isTenantAdministrator();
                // 监测列表数据改变，更新
                $scope.$on('mcLeftData', (ev, data) => {
                    if (data === 'create') {
                        initData();
                    }
                });
                getMessageNum();
                publicToolService.getModeconfiguration('messageLeftShield', 'messageCenter').then((config) => {
                    $scope.status.navigationShield = config;
                });
            }

            /**
         * [autoLocation description] 导航自动定位
         * @return {[type]} [description]
         */
            function autoLocation() {
                $timeout(() => {
                    let routerArray = $state.current.name.split('.');
                    if (routerArray.length == 2) {
                        $element.find('.leve1>a')[0].click();
                        $element.find('.leve1 li a')[0].click();
                    } else {
                        $scope.status.expandedNodes.push(routerArray[2]);
                        $scope.status.selectedLeve2 = routerArray[3];
                        $scope.status.selectedLeve3 = $state.params.id ? $state.params.id : '';
                    }
                });
            }

            /**
         * [getNoticeList description] 获取当前用户启用下的公告包括超管创建的
         * @return {[type]} [description]
         */
            function getNoticeList() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'noticetype',
                    method: 'noticetype',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                    $scope.data.noticeList = data.data;
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
         * [isAdministrator description] 查询当前用户是不是系统管理员
         * @return {Boolean} [description]
         */
            function isAdministrator() {
                permissionService.isAdministrator().then(function(data) {
                    $scope.status.isAdministrator = data;
                }).finally(() => {
                    autoLocation();
                });
            }

            /**
         * [isAdministrator description] 查询当前用户是不是租户管理员
         * @return {Boolean} [description]
         */
            function isTenantAdministrator() {
                permissionService.isTenantAdministrator().then(function(data) {
                    $scope.status.isTenantAdministrator = data;
                });
            }

            /**
             * [getMessageNum description]获取消息数量
             *
             * @return  {[type]}  [return description]
             */
            function getMessageNum() {
                loginService.getCurrLoginUser().then(function(res) {
                    let params = {
                        method: 'queryunreadmsgbyModal',
                        socketid: res.ID,
                        modaltype: '1,2,3,4',
                        serviceid: 'message'
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                        if (data.data && data.data.length) {
                            data.data.forEach((item) => {
                                $scope.status.messageList[item.modaltype] = item.unreadmsg;
                            });
                        }
                    });
                });
            }
            $rootScope.$on('updateMessage', (ev, data) => {
                if (data == 'update') {
                    getMessageNum();
                }
            });

        }
    ]);
